import i18n from "i18next";
import SHA256 from "crypto-js/sha256";
import { getUserEnv } from "./getUserEnv";

export const trackPageView = ({ page_location, page_title, user }) => {
  const email = user?.email || "";
  const hashedEmail = email
    ? SHA256(email.trim().toLowerCase()).toString()
    : null;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "page_view",
    page_location,
    page_title,
    user_env: getUserEnv(),
    user_language: i18n.language,
    ...(hashedEmail && { user_email_hash: hashedEmail }),
  });
};
